import Vue from "vue";
/**
 * 工具类，用于封装通用方法
 */
class toolClass {
	constructor() {}
	/**
	 * @description: 对象数组去重
	 * @param {object} arr
	 * @return:
	 */
	arrToSet(arr) {
		const map = new Map();
		return arr.filter((item) => !map.has(JSON.stringify(item)) && map.set(JSON.stringify(item), 1));
	}
}

export default toolClass;
